import $https from '@/plugins/axios'

const _state = {
  sourceTypeEnum: [],
  typeEnum: []
}

const getters = {
  sourceTypeEnum: state => {
    return state.sourceTypeEnum
  },
  typeEnum: state => {
    return state.typeEnum
  }
}

const mutations = {
  SET_SOURCE_TYPE_ENUM: (state, sourceTypeEnum) => {
    state.sourceTypeEnum = sourceTypeEnum
  },
  SET_TYPE_ENUM: (state, typeEnum) => {
    state.typeEnum = typeEnum
  }
}

const actions = {
  async getSourceTypeEnum ({ state, commit }) {
    if (state.sourceTypeEnum.length === 0) {
      const res = await $https.axios({ method: 'get', url: 'person/get/system/source/type/enum', params: {} })
      commit('SET_SOURCE_TYPE_ENUM', res.data)
    }
  },
  async getTypeEnum ({ state, commit }) {
    if (state.typeEnum.length === 0) {
      const res = await $https.axios({ method: 'get', url: 'person/get/system/type/enum', params: {} })
      commit('SET_TYPE_ENUM', res.data)
    }
  }
}

export default {
  namespaced: true,
  state: _state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cache.js